import axios from 'axios';
import { clearAuthData } from './auth';

// ms-social-publisher fica em outro servidor (kf2:8020).
// VITE_SOCIAL_API_URL override em .env.local pra apontar pra local (localhost:8020)
// ou direto pra produção (http://188.245.174.116:8020).
const SOCIAL_API_BASE_URL =
    import.meta.env.VITE_SOCIAL_API_URL || 'http://188.245.174.116:8020';

const socialApiClient = axios.create({
    baseURL: SOCIAL_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

socialApiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

socialApiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default socialApiClient;
